module.exports = __webpack_public_path__ + "img/kong.9447adb1.png";